class OrganTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('[data-organ-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-organ-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this, tab));
    });
  }

  onTabClick(tab) {
    if (tab.classList.contains('is-active')) return;

    const targetKey = tab.dataset.organTab;

    this.tabs.forEach((otherTab) => {
      const isTarget = otherTab === tab;
      otherTab.classList.toggle('is-active', isTarget);
      otherTab.setAttribute('aria-selected', isTarget);
    });

    this.panels.forEach((panel) => {
      const isTarget = panel.dataset.organPanel === targetKey;
      panel.classList.toggle('is-active', isTarget);
      panel.toggleAttribute('hidden', !isTarget);
    });
  }
}

customElements.define('organ-tabs', OrganTabs);
